import { Outlet } from 'react-router';
import { useResetPromoContractsStoreOnUnmount } from '@/pages/promo-contracts/promo-contracts.store';

export const ContractsLayout = () => {
  useResetPromoContractsStoreOnUnmount();

  return <Outlet />;
};
